// extracted by mini-css-extract-plugin
module.exports = {"solutions":"Solutions_solutions__13R5a","solutions__content":"Solutions_solutions__content__PPRCD","title":"Solutions_title__Whklp","solution":"Solutions_solution__RbYP_"};